import { render, staticRenderFns } from "./DrawerHelp.vue?vue&type=template&id=7b06cd6a"
import script from "./DrawerHelp.vue?vue&type=script&lang=js"
export * from "./DrawerHelp.vue?vue&type=script&lang=js"
import style0 from "./DrawerHelp.vue?vue&type=style&index=0&id=7b06cd6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports